/**
* 头部菜单
*/
<template>
  <el-menu style="display: flex;align-items: center;" class="el-menu-demo" mode="horizontal" background-color="#334157"
    text-color="#fff" active-text-color="#fff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <div style="flex: 1;">

     <div id=""
        style=" width: 300px;color: #FFFFFF;margin-left: 40px;display: flex;align-items: center;">

        <div style="padding-right: 20px;">请选择城市:</div>

        <el-select style="width:100px;flex: 1;" v-model="cityId1" filterable remote placeholder="请输入关键词" size="medium"
          :remote-method="getCityInfoList" @change="remoteMethod1">
          <el-option v-for="item in options" :key="item.cityId" :label="item.cityName" :value="item.cityId">
          </el-option>
        </el-select>
      </div>
    </div>



    <el-submenu index="2" class="submenu">
      <template slot="title">{{user.muRealName}}</template>
      <!--      <el-menu-item index="2-1">设置</el-menu-item>
      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item> -->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
  import {
    loginout,
    getCityInfoList
  } from '../api/userMG'
  export default {
    name: 'navcon',
    data() {
      return {
        collapsed: true,
        imgshow: require('../assets/img/show.png'),
        imgsq: require('../assets/img/sq.png'),
        user: {},
        options: [],
        cityId1:'110000'
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.user = JSON.parse(localStorage.getItem('userdata'))
       this.getCityInfoList()
    },
    methods: {
      remoteMethod1() {
        localStorage.setItem('cityId1', this.cityId1)
      },
     getCityInfoList(query) {
       this.options = []
       let pro = {
           "name": query,
           cityId:''
       }
       getCityInfoList(pro).then(res => {
         if(localStorage.getItem('cityId1')){
           this.cityId1 = localStorage.getItem('cityId1')
         }else{
           localStorage.setItem('cityId1', this.cityId1)
         }
         this.options = res.data
       })
     },
      // 退出登录
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            setTimeout(() => {
              this.$store.commit('logout', 'false')
              this.$router.push({
                path: '/login'
              })
              this.$message({
                type: 'success',
                message: '已退出登录!'
              })
            }, 1000)
            // loginout()
            //   .then(res => {
            //     if (res.success) {
            //       //如果请求成功就让他2秒跳转路由
            //       setTimeout(() => {
            //         this.$store.commit('logout', 'false')
            //         this.$router.push({ path: '/login' })
            //         this.$message({
            //           type: 'success',
            //           message: '已退出登录!'
            //         })
            //       }, 1000)
            //     } else {
            //       this.$message.error(res.msg)
            //       this.logining = false
            //       return false
            //     }
            //   })
            //   .catch(err => {
            //     // 获取图形验证码
            //     this.getcode()
            //     this.logining = false
            //     this.$message.error('退出失败，请稍后再试！')
            //   })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      // 切换显示
      toggle(showtype) {
        this.collapsed = !showtype
        this.$root.Bus.$emit('toggle', this.collapsed)
      }
    }
  }
</script>
<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }

  .submenu {
    float: right;
  }

  .buttonimg {
    height: 60px;
    background-color: transparent;
    border: none;
  }

  .showimg {
    width: 26px;
    height: 26px;
    position: absolute;
    top: 17px;
    left: 17px;
  }

  .showimg:active {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue